module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoom",
    style: (_vm.setHeight)
  }, [_c('pdf', {
    attrs: {
      "src": _vm.currentSheetPdf
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a53cb3d0"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PdfView.vue
// module id = 423
// module chunks = 2